/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import SharedTable from 'shared/ui/Table';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { selectGroupByField } from 'store/Filters/selectors';
import {
  selectHostList,
  selectHostsSelected,
  selectIsFetching
} from 'store/HostsGeneral/selectors';
import { selectFields } from 'store/Preferences/hostsGeneral/selectors';
import { expandGroupByAssetsGeneral, selectHostRow, setOrderByAssetsGeneral, showContextMenu, unSelectAllHosts } from 'store/HostsGeneral/actions';
import hostsGeneralSchema from './schema';
import { Wrapper } from 'Screens/Contextualization/Host/components/Table/styled';
import { selectRiskScoreFeatureFlag } from 'store/Faraday/selectors';
import useTheme from 'Hooks/UseTheme';
import getParsedId from './helper';
import GroupBySubTable from './components/GroupBySubTable';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const Table = () => {
  const { themeStyles } = useTheme();
  const mockData = [...Array(13).keys()];
  const [expanded, setExpanded] = useState([]);
  const dispatch = useDispatch();
  const data = useSelector(selectHostList);
  const isFetching = useSelector(selectIsFetching);
  const fields = useSelector(selectFields);
  const hostsSelected = useSelector(selectHostsSelected);
  const groupByField = useSelector(state => selectGroupByField('assetsGeneral', state));
  const showContextMenuAction = (value, xPos, yPos) => dispatch(showContextMenu(value, xPos, yPos));
  const isAllowedByLicense = useSelector(selectRiskScoreFeatureFlag);
  const isTagsAllowedByLicense = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  const onExpandedChange = (expanded, index) => {
    if (expanded[index]) {
      const expandData = data[index];
      dispatch(expandGroupByAssetsGeneral(index, expandData));
    }
    setExpanded(expanded);
  };

  const isRowSelected = (rowInfo) => !rowInfo.original.count && hostsSelected.filter((x) => x.id === rowInfo.original.id).length > 0;

  const getTrProps = (rowInfo, showContextMenuAction, isFetching) => {
    if (rowInfo && rowInfo.row && !rowInfo.original.count) {
      const selected = isRowSelected(rowInfo);

      return {
        onContextMenu: (e) => {
          e.preventDefault();
          showContextMenuAction(true, e.pageX, e.pageY);
          if (!selected && !isFetching) {
            dispatch(unSelectAllHosts());
            dispatch(selectHostRow(e, rowInfo.original));
          }
        }
      };
    }

    return {};
  };

  const getThProps = (column, fields, showContextMenuAction, isDisplayingContextMenu) => {
    const id = getParsedId(column.id);
    const defaultMin = fields[id] ? fields[id].defaultMin : 0;
    const maxWidth = fields[id] ? fields[id].maxWidth : 0;
    const response = { minWidth: defaultMin, maxWidth };

    return {
      style: defaultMin ? response : {},
      onContextMenu: (e) => {
        e.preventDefault();
        if (isDisplayingContextMenu) showContextMenuAction(false);
      }
    };
  };

  const getSorting = (sorted) => {
    const importantVulnsSortIndex = sorted.findIndex((s) => s.id === 'severity_counts');

    if (importantVulnsSortIndex >= 0) {
      const desc = sorted[importantVulnsSortIndex].desc;
      const sortCriticalCount = { id: 'vulnerability_critical_generic_count', desc };
      const sortHighCount = { id: 'vulnerability_high_generic_count', desc };
      const sortMediumCount = { id: 'vulnerability_medium_generic_count', desc };

      const newSorting = [...sorted];
      newSorting.splice(importantVulnsSortIndex, 1, sortCriticalCount, sortHighCount, sortMediumCount);
      return newSorting;
    }
    return sorted;
  };

  const fetchData = (sorted) => {
    if (!isFetching) {
      const sorting = getSorting(sorted);
      dispatch(setOrderByAssetsGeneral(sorting));
    }
  };
  return (
    <Wrapper>
      <SharedTable
        schema={ hostsGeneralSchema }
        context={ {
          isPivot: false, fields, groupBy: groupByField, isLoading: isFetching, isAllowedByLicense, isTagsAllowedByLicense, theme: themeStyles
        } }
        data={ data }
        isLoading={ isFetching }
        onFetch={ fetchData }
        getRowProps={ (rowInfo) => getTrProps(rowInfo, showContextMenuAction, isFetching) }
        isRowSelected={ isRowSelected }
        getHeaderProps={ (column) => getThProps(column, fields, showContextMenuAction, showContextMenu) }
        noDataText={ !isFetching && <FormattedMessage id="app.nodata" /> }
        expanded={ expanded }
        onExpandedChange={ onExpandedChange }
        SubComponent={ (row) => (
          <GroupBySubTable
            row={ row }
            data={ data }
            fields={ fields }
            groupByField={ groupByField }
            mockData={ mockData }
            themeStyles={ themeStyles }
            getTrProps={ getTrProps }
            isRowSelected={ isRowSelected }
            showContextMenuAction={ showContextMenuAction }
            isFetching={ isFetching }
            isTagsAllowedByLicense={ isTagsAllowedByLicense }
          />
        ) }
      />
    </Wrapper>
  );
};

export default Table;
